module.exports = {
      id: "more-outline-usage",
      viewBox: "0 0 25 25",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#more-outline",
      toString: function () {
        return this.url;
      }
    }